import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import { toCamel } from 'snake-camel';
import moment from "moment";


type NotificationList = {
    id: string;
    title: string;
    content: string;
    publishDate: string;
    isImportant: boolean;
    isRead: boolean;
    selectedNotificationId : string;
};

type NotificationsGet = {
    notifications: NotificationList[];
}

export type Item = {
    id: string;
    publishDate: string;
    title: string;
    isRead: boolean;
    isImportant: boolean;
    isActive: boolean;
}

@Component({
    components: {
        Modal,
    }
})
export default class NotificationModal extends Vue {
    
    @Prop() isShowNotificationModal!: boolean

    private list: any | null = null
    private items: Item[] | undefined = []
    private title = 'お知らせ'
    private isImportantOnly = false
    private searchText = ''
    private activeList: 'DATE' | 'IMPORTANT' = 'DATE'
    private baseUrl = '/notifications';
    private notifications: NotificationList[] = []
    private selectedNotification!: NotificationList
    private isLoading = false
    private notificationId = ""
    private notificationTitle = ""
    private notificationContent = ""
    private notificationPublishDate = ""
    private isImportant = false
    private isRead = false


    @Watch('isShowNotificationModal')
    private showNotifications() {
        if(this.isShowNotificationModal){
            this.getNotifications(this.isImportantOnly)
            this.isActive(this.notificationId);
        }
    }

    private getNotifications(isImportantOnly: boolean) {
        this.list = null
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}?is_important=${isImportantOnly}`).then(res => {
            this.notifications = (toCamel(res) as NotificationsGet).notifications as NotificationList[]
        })
        .finally(() => {
            this.list = this.notifications
            this.items = this.list
            const notiticationUnReadCount = this.notifications.filter((notification:any) => !notification.isRead).length;
            this.$store.dispatch('doUpdateNotificationCount',notiticationUnReadCount);
        })
    }

    private setNotification (id:string,isRead:boolean){
    this.$apiClient.doRequest("get", `/notification_register/${id}`).then((res) => {
        const item = this.selectedNotification = toCamel(res) as NotificationList
            this.notificationId = item.id
            this.notificationTitle = item.title
            this.notificationPublishDate = this.changeDateFormat(item.publishDate)
            this.isImportant = item.isImportant
            this.notificationContent = item.content
            if(!isRead){
                const params = {
                    notificationId: id
                }
            this.$apiClient.doRequest("post", `${this.baseUrl}`, params).then((res) => {
                this.getNotifications(this.isImportantOnly);
            });
            }
            this.isActive(id);
        });
    }

    convertToHTML(content:string) {
      // Define the regular expression pattern
      const pattern = /<@@URL>(.*?)<&&>(.*?)<\/@@URL>/gs;

      // Replace each occurrence of the pattern with HTML
      const convertedContent = content.replace(pattern, (match, url, label) => {
        // Create a hyperlink element
        const hyperlink = document.createElement('a');
        hyperlink.href = url;
        hyperlink.textContent = label;
        hyperlink.target = '_blank'; // Open link in a new tab

        // Return the HTML content
        return hyperlink.outerHTML;
      });
      // Preserve line breaks in the content
      const preservedContent = convertedContent.replace(/\n/g, '<br>');

     // Return the final converted HTML content with preserved line breaks
    return preservedContent;
    }

    private isActive(id:string){
    setTimeout(() => {
     const newItems: Item[] = []
     this.items?.forEach((val) => {
            if(id === val.id){
                val.isActive = true
            }else {
                val.isActive = false
            }
            newItems.push(val)
        })
        this.items = newItems
     }, 200);
    }

    @Watch('searchText')
    private doSearch() {
        this.init();
    }

    private init(){
        const filteredByKeyword = this.searchText ? this.list?.filter((item: Item) => item.title.indexOf(this.searchText) > -1): this.list;
        const sortArray: Item[] = filteredByKeyword
        if(this.activeList === 'IMPORTANT') {
            this.items = sortArray.sort((a, b) => (a.isImportant === b.isImportant ? 0 : a.isImportant ? -1 : 1));
        }else if(this.activeList === 'DATE'){
            this.items = sortArray.sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());
        }
    }
    private toggleImportantItems(){
        this.isImportantOnly = !this.isImportantOnly
        this.getNotifications(this.isImportantOnly);
        this.isActive(this.notificationId);
    }
   
    closeModal(){
        this.$emit('update:isShowNotificationModal', false);
    }
    
    openSideBar = () => {
        if(document.body.classList.contains('newsSide')){
            document.body.classList.remove('newsSide')
        }else{
            document.body.classList.add('newsSide')
        }
    }

    private changeDateFormat(inputDate: string): string {
           const utcDate = new Date(inputDate);
           const newDateFormat= moment(utcDate).format('YYYY/MM/DD HH:mm:ss')
           return newDateFormat;
           return newDateFormat;
    }
}